
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/start",
      function () {
        return require("private-next-pages/start/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/start"])
      });
    }
  